import { useParams, useNavigate } from "react-router-dom";
import React, { useEffect, useState } from "react";

const API_BASE = "https://api.mariamlyluxe.com/public";

export default function CategoryDetailsPage() {
  const { slug } = useParams();
  const nav = useNavigate();
  const [cat, setCat] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    (async () => {
      try {
        // عدّل الـ API حسب المتوفر عندك
        const r = await fetch(`${API_BASE}/api/categories?slug=${encodeURIComponent(slug)}`, { headers: { Accept: "application/json" } });
        if (!r.ok) throw new Error(`Failed: ${r.status}`);
        const j = await r.json();
        const c = Array.isArray(j?.categories) ? j.categories[0] : null;
        setCat(c);
      } catch (e) {
        setError("Category not found.");
        console.warn(e);
      } finally {
        setLoading(false);
      }
    })();
  }, [slug]);

  if (loading) return <p>Loading category…</p>;
  if (error || !cat) return <p style={{ color: "crimson" }}>{error || "Not found."}</p>;

  return (
    <section>
      <button onClick={() => nav(-1)} style={{ marginBottom: 12 }}>← Back</button>
      <h1>{cat.name}</h1>
      {cat.image_url && <img src={cat.image_url} alt={cat.name} style={{ maxWidth: 640, display: "block", marginBottom: 12 }} />}
      <p>Browse products for this category:</p>
      <a href={`/shop?category=${cat.id}`} style={{ color: "#0f62fe" }}>Go to Shop</a>
    </section>
  );
}
